import React from 'react';
import CheckboxField from '@react/Common/CheckboxField/CheckboxField';

interface ToggleListItemOwnProps {
  item: {
    id: string | number;
    name?: string;
    selected?: boolean;
  };
}

interface ToggleListItemDispatchProps {
  toggleItem: (item) => void;
  chooseItemId?: (item) => string | number;
  chooseItemName?: (item) => string;
}

type ToggleListItemProps = ToggleListItemOwnProps & ToggleListItemDispatchProps;

export const ToggleListItemComponent: React.FC<ToggleListItemProps> = ({
  item,
  chooseItemId = item => item.id,
  chooseItemName = item => item.name,
  toggleItem,
}) => (
  <CheckboxField
    id={chooseItemId(item)}
    name={chooseItemName(item)}
    value={item.selected || false}
    onChange={() => toggleItem(item)}
  />
);
